'use strict';
var React = require('react');
var _ = require('underscore');
var IconPart = require('../common/IconParts');
var styleHelper = require('../../helper/styleHelper');

/**
 * 告警图标
 * @author mxj
 */
var AlarmIcon = React.createClass({
  render: function () {
    var props = _.extend({},this.props);

    this.builderIconProps(props);

    return (
      <div className="alarm-icon-content">
        <div className="round-rect" style={this.getRectStyle()}>
        </div>
        <span className="alarm-text" style={this.builderTextStyle()}>2</span>
        <div className="alarm-icon" style={this.getIconWapperStyle()}>
          <IconPart {...props}/>
        </div>
      </div>
    )
  },

  builderIconProps : function(props){
    var s = styleHelper.getWidth(this.props);
    props.defaultIcon = 'email.png';
    props.color = '#444';
    props.h = props.w = styleHelper.getWidth(this.props) * 6/7 - 24;
    props.x = props.y = (s - props.h)/2;
  },

  getRectStyle: function () {
    return {
      width: styleHelper.getWidth(this.props) * 6 / 7,
      height: styleHelper.getHeight(this.props) * 6 / 7
    };
  },

  builderTextStyle: function () {
    return {
      width: styleHelper.getWidth(this.props) * 2 / 7,
      height: styleHelper.getHeight(this.props) * 2 / 7,
      lineHeight: styleHelper.getHeight(this.props) * 2 / 7 + 'px'
    };
  },

  getIconWapperStyle: function () {
    return {
      left: 0,
      top: 0//styleHelper.getHeight(this.props) / 7 + 12
    };
  }
});

module.exports = AlarmIcon;


/** WEBPACK FOOTER **
 ** ./src/views/Components/AlarmIcon.jsx
 **/